import { authHttp } from '../http'
import * as routes from '../../routes/patio.routes'
import { errorHandler } from '../../../util/error.service'

export async function getBalancas(tp_id) {
  try {
    const { data } = await authHttp().get(routes.urlGetBalancas(tp_id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getBalancasActived(tp_id) {
  try {
    const { data } = await authHttp().get(routes.urlGetBalancasActived(tp_id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveBalanca(payload) {
  try {
    const { data } = await authHttp().post(routes.urlPostBalanca, payload)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
